import styled from "@emotion/styled";
import Typography from '@mui/material/Typography';
import { TextProps } from "./text.types";

export default styled(Typography) <TextProps>`
    direction: ${props => props.direction ? props.direction : "rtl"};
    margin: ${props => props.margin ? props.margin : "0"};
    font-size: ${props => props.fontSize ? props.fontSize : "inherit"};
    color: ${(props) => props.color ? props.color : "inherit"};
    -webkit-text-stroke-color: ${(props) => props.stroke ? props.stroke : "#fff"};;
    -webkit-text-stroke-width: ${(props) => props.stroke ? props.strokeFont ? props.strokeFont : "2px" : "0px"};;
    align-self: ${(props) => props.alignSelf ? props.alignSelf : "none"};
    padding: ${(props) => props.padding ? props.padding : "initial"};
    text-wrap: ${(props) => props.textWrap ? props.textWrap : "unset"};
    ${(props) => props.gradient ? "background:" + props.gradient + ";" : ""}
    ${(props) => props.gradient ? "-webkit-background-clip: text;" : ""}
    ${(props) => props.gradient ? "-webkit-text-fill-color: transparent;" : ""}
    max-width: ${props => props.maxWidth ? props.maxWidth : "initial"};
    width: ${props => props.width ? props.width : "initial"};
    height: ${props => props.maxHeight ? props.maxHeight : "initial"};
    overflow: ${props => props.overflow ? props.overflow : "initial"};
    text-overflow: ${props => props.textOverflow ? props.textOverflow : "initial"};
    text-align: ${props => props.textAlign ? props.textAlign : "initial"};
    text-transform: ${props => props.textTransform ? props.textTransform : "initial"};
    cursor: ${props => props.cursor ? props.cursor : ""};
    font-family:${props => props.fontFamily ? props.fontFamily : "'Yekan !important'"};
    transition-timing-function: ease-in;
    white-space: ${props => props.whiteSpace ? props.whiteSpace : "initial"};
    transition-delay: 0s;
    font-weight: ${props => props.fontWeight ? props.fontWeight : "normal"};
    line-height: ${props => props.lignHeight ? props.lignHeight : "30px"};
    display: flex;
    flex-direction: row;
    flex-wrap:${props => props.flexWrap ? props.flexWrap : ""};
    text-decoration:${props => props.textDecoration ? props.textDecoration : "none"};
    align-items: ${props => props.alignItems ? props.alignItems : "center"};
    justify-content: ${props => props.justifyContent ? props.justifyContent : "center"};
    &:hover{
        background:${props => props.hoveredBg ? props.hoveredBg : ""};
        // color:${props => props.hoveredColor ? props.hoveredColor : "inherit"};
        transform:${props => props.hoverTransform ? props.hoverTransform : "inherit"};
        
    }
`